import usePassportMemberStatuses from '@/hooks/approval/usePassportMemberStatuses';

const EMPTY_SET = new Set<string>();

/**
 * passportId 목록의 퇴사(비활성) 여부를 서버 기준으로 판정.
 * 검색/최근선택/최근결재라인/편집 hydrate 등 진입 경로와 무관하게
 * '현재 목록에 들어있는 사람 전체'를 대상으로 쓰는 것이 목적.
 * 문서 단위 조회(useDeactivatedApprovers)와 달리 documentId가 필요 없다.
 */
const useDeactivatedUsers = (passportIds: string[]) => {
  const { data, isResolved, isLoading, error } =
    usePassportMemberStatuses(passportIds);

  // error 면 deactivatedIds 는 빈 셋 — 배지는 그냥 안 뜨지만,
  // 상신 차단하는 쪽은 error 를 보고 보류해야 구멍이 안 생긴다.
  return {
    deactivatedIds: data?.deactivatedIds ?? EMPTY_SET,
    /** 판정 근거가 도착했는지. 아직이면 '퇴사 아님'으로 단정하면 안 된다. */
    isResolved,
    isLoading,
    error,
  };
};

export default useDeactivatedUsers;
